/**
 * Shared column grid for every work-item list in the shell (My work, the client Close tab's "Open items
 * across the client", the file Close tab's checklist): a real header row and fixed column tracks so rows
 * line up regardless of title length, modeled on the Accounts tab's header styling (Sean 2026-09-12
 * 08:36: "the right-side cells do not line up"). `withLocation` adds the Client · File and Period
 * columns (My work, client Close); the file Close tab omits them since every row is already on one file
 * and one period. The Assignee track is wide enough for "File agent · needs Definitions" (tasks review 2026-09-20:
 * the name truncates, the state suffix never does).
 */
export function taskGridCols(withLocation: boolean): string {
  return withLocation
    ? 'minmax(0,1fr) 160px 72px 96px minmax(200px,240px) 72px'
    : 'minmax(0,1fr) 140px minmax(200px,240px) 72px'
}

export function TaskTableHeader({ withLocation }: { withLocation: boolean }) {
  return (
    <div
      className="grid items-center gap-4 border-b border-secondary px-2 pb-2 text-xs font-medium text-tertiary"
      style={{ gridTemplateColumns: taskGridCols(withLocation) }}
      data-testid="task-table-header"
      role="row"
    >
      <span role="columnheader">Item</span>
      {withLocation ? <span role="columnheader">Client · File</span> : null}
      {withLocation ? <span role="columnheader">Period</span> : null}
      <span role="columnheader">Status</span>
      <span role="columnheader">Assignee</span>
      <span role="columnheader" className="text-right">Due</span>
    </div>
  )
}
